<template>
  <div >
    <el-form inline size="small">
      <el-form-item label="来源ID">
        <el-input v-model="searchParams.source_product_id" placeholder="请输入来源ID" clearable style="width: 150px;"></el-input>
      </el-form-item>
      <el-form-item label="批次号">
        <el-input v-model="searchParams.batch_no" placeholder="请输入批次号" clearable style="width: 150px;"></el-input>
      </el-form-item>
      <el-form-item label="关键词">
        <el-input v-model="searchParams.keyword" placeholder="请输入商品标题" clearable ></el-input>
      </el-form-item>
      <el-form-item label="sku替换状态">
        <el-select v-model="searchParams.sku_status" placeholder="全部" clearable size="small" style="width: 150px;">
          <el-option v-for="item in Object.keys(skuStatus)" :key="item" :label="skuStatus[item].label" :value="skuStatus[item].value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否包邮">
        <el-select v-model="searchParams.distribution_free_postage" placeholder="全部" clearable size="small" style="width: 120px;">
          <el-option label="包邮" value="1"></el-option>
          <el-option label="不包邮" value="0"></el-option>
          <el-option label="未知" value="unknown"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="运费显示省份">
        <el-select v-model="searchParams.freight_province_code" placeholder="选择后新增运费显示" clearable size="small" style="width: 160px;">
          <el-option v-for="province in provinceOptions" :key="province.value" :label="province.label" :value="province.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="价格区间">
        <el-input v-model="searchParams.min_price" inputmode="decimal" placeholder="最低价" clearable style="width: 100px;"></el-input>
        <span class="price-range-separator">-</span>
        <el-input v-model="searchParams.max_price" inputmode="decimal" placeholder="最高价" clearable style="width: 100px;"></el-input>
      </el-form-item>
      <el-form-item label="触发铺货成功">
        <el-select v-model="searchParams.has_distribute_success" placeholder="全部" clearable size="small" style="width: 120px;">
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="触发铺货失败">
        <el-select v-model="searchParams.has_distribute_fail" placeholder="全部" clearable size="small" style="width: 120px;">
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="触发商品封禁">
        <el-select v-model="searchParams.has_distribute_ban" placeholder="全部" clearable size="small" style="width: 120px;">
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="触发商品驳回">
        <el-select v-model="searchParams.has_distribute_review_fail" placeholder="全部" clearable size="small" style="width: 120px;">
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="排除已铺货">
        <el-select v-model="searchParams.exclude_distributed" placeholder="不排除" multiple collapse-tags clearable @change="handleExcludeFilterChange" size="small" style="width: 200px;">
          <el-option label="排除全部已铺货" value="all"></el-option>
          <el-option v-for="shop in excludeShopList" :key="shop.shop_id" :label="shop.shop_name" :value="String(shop.shop_id)" :disabled="searchParams.exclude_distributed.includes('all')"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="铺货状态" v-if="searchParams.exclude_distributed && searchParams.exclude_distributed.length > 0">
        <el-select v-model="searchParams.distribute_status" placeholder="全部" clearable  size="small" style="width: 120px;">
          <el-option label="待铺货" :value="1"></el-option>
          <el-option label="铺货中" :value="2"></el-option>
          <el-option label="铺货失败" :value="3"></el-option>
          <el-option label="铺货成功" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分组">
        <el-select v-model="searchParams.group_id" placeholder="全部分组" filterable clearable size="small" style="width: 150px;" @change="changeSetGroupId">
          <el-option v-for="group in groupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="子分组">
        <el-select v-model="searchParams.child_group_id" placeholder="全部子分组" filterable clearable size="small" style="width: 150px;">
          <el-option v-for="group in child_groupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="handleSearch">查询</el-button>
        <el-button size="small" @click="refresh">重置</el-button>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 15px;">
      <el-button type="success" @click="handleCloudDistribute" size="small" :disabled="selectedList.length === 0">
        <i class="el-icon-s-goods"></i>铺货({{selectedList.length}})
      </el-button>
    </div>
    <el-table v-loading="loading" :data="tableData" @selection-change="selectChange"
              :header-cell-style="{ background: '#eef1f6', color: '#606266' }" class="rc_table" row-key="id" >
      <el-table-column type="selection" width="50" align="center"></el-table-column>
      <el-table-column label="商品信息"  min-width="140">
        <template #default="{ row }">
          <div class="goods-box">
            <img :src="row.main_image" class="goods-img">
            <div class="goods-info">
              <el-tooltip class="item" effect="dark" :content="row.title" placement="top" :open-delay="300">
                <div class="goods-title">{{row.title}}</div>
              </el-tooltip>
              <div>价格：{{row.price}}</div>
              <div>来源ID：{{row.source_product_id}}</div>
              <div :class="skuStatus[row.sku_status].type">{{skuStatus[row.sku_status].label}}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运费" align="center" width="170">
        <template #default="{ row }">
          <div>是否包邮：{{ row.distribution_free_postage === true ? '是' : (row.distribution_free_postage === false ? '否' : '未知') }}</div>
          <div v-if="searchParams.freight_province_code">发往{{ provinceName(searchParams.freight_province_code) }}：{{ row.destination_freight_status === 'unknown' ? '未知' : row.destination_freight + ' 元' }}</div>
          <el-button v-if="row.distribution_free_postage === false" type="text" size="mini" @click="handleViewFreight(row)">查看运费</el-button>
        </template>
      </el-table-column>
      <el-table-column label="分组|子分组" prop="group_name" align="center" width="200">
            <template #default="{ row }">
                <el-tooltip v-if="row.group_name" :content="formatGroupName(row)" placement="top" :open-delay="300">
                    <span class="group-name-cell">{{ formatGroupName(row) }}</span>
                </el-tooltip>
                <span v-else>-</span>
            </template>
      </el-table-column>
      <el-table-column label="铺货信息统计" align="center" width="130">
        <template #default="{ row }">
          <div>铺货成功：{{ row.distribute_success_count || 0 }}</div>
          <div>铺货失败：{{ row.distribute_fail_count || 0 }}</div>
          <div>商品封禁：{{ row.distribute_ban_count || 0 }}</div>
          <div>商品驳回：{{ row.distribute_review_fail_count || 0 }}</div>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" width="120">
        <template #default="{ row }">
          <div class="status-container">
            <div class="status-tag">
              <el-tag :type="itemStatusTag[row.status]" size="small">{{row.status_text}}</el-tag>
            </div>
            <div v-if="row.status === 2 || row.status === 3" class="error-message-under-status" :title="row.error_msg">
              {{ row.error_msg || '' }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="时间" align="center" width="170">
        <template #default="{ row }">
          <div class="time-column">
            <div>创建: {{row.created_at_text}}</div>
            <div>更新: {{row.updated_at_text}}</div>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getDataList" layout="total, sizes, prev, pager, next, jumper" v-if="page_data.total>0" />

    <!-- 云商品铺货弹窗 -->
    <el-dialog title="铺货到店铺(只显示授权正常的店铺)" :visible.sync="cloudDistributeShow" width="600px">
      <div v-loading="cloudShopLoading" class="shop-distribute-container">
        <el-tabs v-model="cloudShopTab">
          <!-- 抖店Tab -->
          <el-tab-pane :label="'抖店 (' + cloudShopListByType.douyin.length + ')'" name="douyin">
            <div class="shop-tab-header" v-if="cloudShopListByType.douyin.length > 0">
              <el-checkbox
                  v-model="cloudDouyinCheckAll"
                  :indeterminate="cloudDouyinIndeterminate"
                  @change="handleDouyinCheckAllChange"
              >全选</el-checkbox>
              <el-select v-model="cloudSelectedShopIds" multiple collapse-tags filterable clearable
                    placeholder="请选择店铺" size="mini" style="width: 280px; margin-left: 10px;"
                    @change="handleShopSelectionChange">
                    <el-option v-for="shop in cloudShopListByType.douyin" :key="shop.shop_id"
                        :label="shop.shop_name" :value="shop.shop_id"></el-option>
                </el-select>
            </div>
            <div class="shop-tab-content" v-if="cloudShopListByType.douyin.length > 0">
              <el-checkbox-group v-model="cloudSelectedShopIds" @change="handleShopSelectionChange">
                <div class="shop-item" v-for="shop in cloudShopListByType.douyin" :key="shop.shop_id">
                  <el-checkbox :label="shop.shop_id">
                    <span class="shop-name">{{shop.shop_name}}</span>
                  </el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
            <el-empty v-else description="暂无抖店" :image-size="80"></el-empty>
          </el-tab-pane>
          <!-- 微信小店Tab -->
          <el-tab-pane :label="'微信小店 (' + cloudShopListByType.wechat.length + ')'" name="wechat">
            <div class="shop-tab-header" v-if="cloudShopListByType.wechat.length > 0">
              <el-checkbox
                  v-model="cloudWechatCheckAll"
                  :indeterminate="cloudWechatIndeterminate"
                  @change="handleWechatCheckAllChange"
              >全选</el-checkbox>
              <el-select v-model="cloudSelectedShopIds" multiple collapse-tags filterable clearable
                    placeholder="请选择店铺" size="mini" style="width: 280px; margin-left: 10px;"
                    @change="handleShopSelectionChange">
                    <el-option v-for="shop in cloudShopListByType.wechat" :key="shop.shop_id"
                        :label="shop.shop_name" :value="shop.shop_id"></el-option>
                </el-select>
            </div>
            <div class="shop-tab-content" v-if="cloudShopListByType.wechat.length > 0">
              <el-checkbox-group v-model="cloudSelectedShopIds" @change="handleShopSelectionChange">
                <div class="shop-item" v-for="shop in cloudShopListByType.wechat" :key="shop.shop_id">
                  <el-checkbox :label="shop.shop_id">
                    <span class="shop-name">{{shop.shop_name}}</span>
                  </el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
            <el-empty v-else description="暂无微信小店" :image-size="80"></el-empty>
          </el-tab-pane>
        </el-tabs>
        <el-empty v-if="cloudShopList.length === 0 && !cloudShopLoading" description="暂无可用店铺"></el-empty>
      </div>
      <template #footer>
        <span class="selected-count">已选择 {{cloudSelectedShopIds.length}} 个店铺</span>
        <el-button @click="cloudDistributeShow = false">取消</el-button>
        <el-button @click="submitCloudDistribute" type="primary" :loading="cloudDistributeLoading">确定铺货</el-button>
      </template>
    </el-dialog>
    <el-dialog title="各省首件运费" :visible.sync="freightDetailVisible" width="500px" append-to-body>
      <el-table v-loading="freightDetailLoading" :data="freightDetails" max-height="420" size="small">
        <el-table-column prop="province_name" label="发往省份" align="center"></el-table-column>
        <el-table-column label="首件运费" align="center">
          <template #default="{ row }">
            {{ row.destination_freight_status === 'calculated' ? row.destination_freight + ' 元' : '未知' }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import {mapActions} from "vuex";
import areaData from '@/assets/js/data/area.js';

import Pagination from "@/components/pagination/pagination.vue";

const MAINLAND_PROVINCE_CODES = ['110000', '120000', '130000', '140000', '150000', '210000', '220000', '230000', '310000', '320000', '330000', '340000', '350000', '360000', '370000', '410000', '420000', '430000', '440000', '450000', '460000', '500000', '510000', '520000', '530000', '540000', '610000', '620000', '630000', '640000', '650000', '710000', '810000', '820000'];

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      dataInfo:{},
      loading: false,
      tableData: [],
      freightDetailVisible: false,
      freightDetailLoading: false,
      freightDetails: [],
      page_data: {
        limit: 10,
        page: 1,
        total:0,
      },
      searchParams:{
        source_product_id:'',
        status: '',
        keyword: '',
        batch_no: '',
        sku_status: '',
        distribution_free_postage: '',
        freight_province_code: '',
        min_price: '',
        max_price: '',
        exclude_distributed: [],
        distribute_status: '',
        group_id: '',
        child_group_id: '',
        has_distribute_success: '',
        has_distribute_fail: '',
        has_distribute_ban: '',
        has_distribute_review_fail: ''
      },
      skuStatus:{
        1:{label:'待替换',value:1,type:'selected-tag'},
        2:{label:'已替换',value:2,type:'replaced-tag'},
        3:{label:'找不到',value:3,type:'notFond-tag'}
      },
      itemStatusTag: ['primary', 'success', 'danger', 'info'], // 0待处理 1成功 2失败 3重复跳过
      excludeShopList: [], // 排除已铺货店铺列表,
      groupList:[],
      child_groupList:[],
      provinceOptions: MAINLAND_PROVINCE_CODES.map(value => ({ value, label: areaData.province_list[value] })),
      selectedList:[],
      // 云商品铺货弹窗
      cloudDistributeShow: false,
      cloudShopList: [],
      cloudShopLoading: false,
      cloudCheckAll: false,
      cloudIsIndeterminate: false,
      cloudTableKey: Math.random(),
      cloudDistributeLoading: false,
      cloudSelectedShopIds: [], // 选中的店铺ID列表
      cloudShopTab: 'douyin', // 店铺Tab切换，默认抖店
      sourceProductId:''
    }
  },
  created() {
    if(this.$route?.query?.tab==='share'){
      this.sourceProductId = this.$route?.query?.source_product_id??''
    }
  },
computed:{
  // 按店铺类型分组
  cloudShopListByType() {
    const douyin = this.cloudShopList.filter(item => item.shop_type == 1)
    const wechat = this.cloudShopList.filter(item => item.shop_type == 7)
    return { douyin, wechat }
  },
  // 抖店全选状态
  cloudDouyinCheckAll: {
    get() {
      const douyinIds = this.cloudShopListByType.douyin.map(s => s.shop_id)
      if (douyinIds.length === 0) return false
      return douyinIds.every(id => this.cloudSelectedShopIds.includes(id))
    },
    set() {}
  },
  cloudDouyinIndeterminate() {
    const douyinIds = this.cloudShopListByType.douyin.map(s => s.shop_id)
    if (douyinIds.length === 0) return false
    const selected = douyinIds.filter(id => this.cloudSelectedShopIds.includes(id))
    return selected.length > 0 && selected.length < douyinIds.length
  },
  // 微信店铺全选状态
  cloudWechatCheckAll: {
    get() {
      const wechatIds = this.cloudShopListByType.wechat.map(s => s.shop_id)
      if (wechatIds.length === 0) return false
      return wechatIds.every(id => this.cloudSelectedShopIds.includes(id))
    },
    set() {}
  },
  cloudWechatIndeterminate() {
    const wechatIds = this.cloudShopListByType.wechat.map(s => s.shop_id)
    if (wechatIds.length === 0) return false
    const selected = wechatIds.filter(id => this.cloudSelectedShopIds.includes(id))
    return selected.length > 0 && selected.length < wechatIds.length
  }
},
  watch: {
    cloudShopList: {
      handler() {
        let checkedCount = this.cloudShopList.filter(item => item.is_selected == 1).length;
        this.cloudCheckAll = checkedCount === this.cloudShopList.length && this.cloudShopList.length > 0;
        this.cloudIsIndeterminate = checkedCount > 0 && checkedCount < this.cloudShopList.length;
        this.cloudTableKey = Math.random()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...mapActions({
      getShareCloudProductList: 'ucenter/getShareCloudProductList',
      getCloudProductFreightDetails: 'ucenter/getCloudProductFreightDetails',
      getDistributeShopSel: 'ucenter/getDistributeShopSel',
      createCloudProductDistribute: 'ucenter/createCloudProductDistribute',
      getCloudProductGroups: 'ucenter/getShareCloudProductGroups',
    }),
    initData(){

      this.refresh()
      this.getExcludeShopList()
      this.loadGroupList()
    },
    // 获取排除已铺货店铺列表
    getExcludeShopList() {
      this.getDistributeShopSel({
        data: {},
        success: (res) => {
          if (res.code === 200) {
            this.excludeShopList = res.data || []
          }
        }
      })
    },
    // 获取分组列表（筛选用，不需要数量）
    loadGroupList() {
      this.getCloudProductGroups({
        data: { with_count: 0 },
        success: (res) => {
          if (res.code === 200) {
            this.groupList = res.data || []
          }
        }
      })
    },
    //获取列表
    getDataList() {
      this.loading = true
      let params = {page_size:this.page_data.limit,page:this.page_data.page,...this.searchParams}
      // 移除空字符串参数
      if (params.status === '') delete params.status
      if (params.keyword === '') delete params.keyword
      if (params.batch_no === '') delete params.batch_no
      if (params.sku_status === '') delete params.sku_status
      if (params.distribution_free_postage === '') delete params.distribution_free_postage
      if (params.freight_province_code === '') delete params.freight_province_code
      if (params.min_price === '') delete params.min_price
      if (params.max_price === '') delete params.max_price
      if (params.distribute_status === '') delete params.distribute_status
      if (params.has_distribute_success === '') delete params.has_distribute_success
      if (params.has_distribute_fail === '') delete params.has_distribute_fail
      if (params.has_distribute_ban === '') delete params.has_distribute_ban
      if (params.has_distribute_review_fail === '') delete params.has_distribute_review_fail
      // 处理排除已铺货参数，多个店铺ID用逗号分隔
      if (params.exclude_distributed && params.exclude_distributed.length > 0) {
        params.exclude_distributed = params.exclude_distributed.join(',')
      } else {
        delete params.exclude_distributed
      }
      if (params.group_id === '') delete params.group_id
      this.getShareCloudProductList({
        data: params,
        success: (res) => {
          this.loading = false
          if (res.code == 200) {
            this.tableData = res.data.list
            this.page_data.total = res.data.total
          } else {
            this.$message.error(res.message)
          }

        }
      })
    },

    handleSearch(){
      const minPrice = String(this.searchParams.min_price || '').trim()
      const maxPrice = String(this.searchParams.max_price || '').trim()
      if (minPrice !== '' && (!Number.isFinite(Number(minPrice)) || Number(minPrice) < 0)) {
        this.$message.warning('最低价格必须是大于等于0的数字')
        return
      }
      if (maxPrice !== '' && (!Number.isFinite(Number(maxPrice)) || Number(maxPrice) < 0)) {
        this.$message.warning('最高价格必须是大于等于0的数字')
        return
      }
      if (minPrice !== '' && maxPrice !== '' && Number(minPrice) > Number(maxPrice)) {
        this.$message.warning('最低价格不能大于最高价格')
        return
      }
      this.page_data.page = 1
      this.getDataList()
    },
    refresh(){
      this.page_data.page = 1
      this.page_data.total = 0
      this.searchParams = {
        source_product_id:this.sourceProductId||'',
        status: '',
        keyword: '',
        batch_no: '',
        sku_status: '',
        distribution_free_postage: '',
        freight_province_code: '',
        min_price: '',
        max_price: '',
        exclude_distributed: [],
        distribute_status: '',
        group_id: '',
        has_distribute_success: '',
        has_distribute_fail: '',
        has_distribute_ban: '',
        has_distribute_review_fail: ''
      }
      this.getDataList()
      this.sourceProductId=''
    },

    provinceName(code) {
      return areaData.province_list[code] || ''
    },

    handleViewFreight(row) {
      this.freightDetailVisible = true
      this.freightDetailLoading = true
      this.freightDetails = []
      this.getCloudProductFreightDetails({
        id: row.id,
        data: { shared: 1 },
        success: (res) => {
          this.freightDetailLoading = false
          if (res.code === 200) {
            this.freightDetails = res.data.freights || []
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },

    // 排除已铺货筛选变化
    handleExcludeFilterChange(val) {
      // 如果选择了"排除全部"，清除其他店铺选项
      if (val.includes('all') && val.length > 1) {
        this.searchParams.exclude_distributed = ['all']
      }
      // 如果清空了排除已铺货，也清空铺货状态筛选
      if (!val || val.length === 0) {
        this.searchParams.distribute_status = ''
      }
      // this.searchParams.status = ''
      // this.handleCloudSearch()
    },
    selectChange(e){
      this.selectedList = [...e]
    },
    // 云商品铺货
    handleCloudDistribute() {
      // 按钮已经被禁用，但保留检查防止意外情况
      if (this.selectedList.length === 0) {
        this.$message.warning('请先选择要铺货的商品')
        return
      }

      // 检查是否有成功状态的商品
      const successProducts = this.selectedList.filter(item => item.status === 1)
      if (successProducts.length === 0) {
        this.$message.warning('请选择成功状态的商品进行铺货')
        return
      }

      if (successProducts.length < this.selectedList.length) {
        this.$message.warning(`已过滤非成功状态的商品，将对 ${successProducts.length} 个商品进行铺货`)
        // 更新选中列表为只包含成功的商品
        this.selectedList = successProducts
      }

      this.cloudDistributeShow = true
      this.cloudShopLoading = true
      this.cloudSelectedShopIds = [] // 重置选中店铺
      this.cloudShopTab = 'douyin' // 重置为默认抖店Tab
      // 获取店铺列表，铺货需要status=1的店铺
      this.getDistributeShopSel({
        data: { status: 1 },
        success: (res) => {
          if (res.code === 200) {
            this.cloudShopList = (res.data || []).map(item => ({ ...item, is_selected: 0 }))
          } else {
            this.$message.error(res.message)
          }
          this.cloudShopLoading = false
        }
      })
    },

    // 抖店分组全选
    handleDouyinCheckAllChange(checked) {
      const douyinIds = this.cloudShopListByType.douyin.map(s => s.shop_id)
      if (checked) {
        // 添加所有抖店ID
        const newIds = [...this.cloudSelectedShopIds]
        douyinIds.forEach(id => {
          if (!newIds.includes(id)) newIds.push(id)
        })
        this.cloudSelectedShopIds = newIds
      } else {
        // 移除所有抖店ID
        this.cloudSelectedShopIds = this.cloudSelectedShopIds.filter(id => !douyinIds.includes(id))
      }
    },

    // 微信店铺分组全选
    handleWechatCheckAllChange(checked) {
      const wechatIds = this.cloudShopListByType.wechat.map(s => s.shop_id)
      if (checked) {
        const newIds = [...this.cloudSelectedShopIds]
        wechatIds.forEach(id => {
          if (!newIds.includes(id)) newIds.push(id)
        })
        this.cloudSelectedShopIds = newIds
      } else {
        this.cloudSelectedShopIds = this.cloudSelectedShopIds.filter(id => !wechatIds.includes(id))
      }
    },

    // 店铺选择变化
    handleShopSelectionChange(val) {
      this.cloudSelectedShopIds = val
    },
    submitCloudDistribute() {
      if (!this.cloudSelectedShopIds.length) {
        this.$message.error("请选择要铺货的店铺")
        return
      }
      const product_ids = this.selectedList.map(item => item.id)
      this.cloudDistributeLoading = true
      this.createCloudProductDistribute({
        data: {
          product_ids: product_ids,
          shop_ids: this.cloudSelectedShopIds,
          is_share:1
        },
        success: (res) => {
          if (res.code === 200) {
            this.$message.success(res.message)
            this.cloudDistributeShow = false
            this.selectedList = []
            this.cloudSelectedShopIds = []
            this.getDataList() // 刷新列表
          } else {
            this.$message.error(res.message)
          }
          this.cloudDistributeLoading = false
        }
      })
    },
    changeSetGroupId(val) {
        this.$set(this.searchParams, 'child_group_id', '')
        const target = this.groupList.find(i => i.id === val)
        this.child_groupList = target?.child_groups || []
    },
    formatGroupName(row) {
        let group_name = row.group_name
        const target = this.groupList.find(i => i.id === row.group_id)?.child_groups?.find(i => i.id === row.child_group_id)
        const child_group_name = target?.name
        if(child_group_name) {
            group_name += '|'+child_group_name
        }
        return group_name;
    },

  }
}
</script>


<style scoped lang="scss">
/* 商品信息样式 */
.goods-box {
  display: flex;
  align-items: flex-start;
  width: 100%;
  /*max-width: 280px;*/ /* 限制最大宽度 */
  flex: 1;
}

.goods-img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  margin-right: 8px;
  border-radius: 4px;
  flex-shrink: 0; /* 防止图片被压缩 */
}

.goods-info {
  flex: 1;
  font-size: 12px;
  line-height: 1.5;
  min-width: 0; /* 允许内容收缩 */
  overflow: hidden;
}

.goods-info > div:not(.goods-title) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 2px;
}

.goods-title {
  font-size: 13px;
  font-weight: 500;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal; /* 标题允许换行 */
  margin-bottom: 4px;
}
/*表格中时间样式*/
.time-column {
  font-size: 12px;
  line-height: 1.6;
  color: #606266;
}

.time-column > div {
  white-space: nowrap;
}

/* 铺货弹窗店铺Tab样式 */
.shop-distribute-container {
  min-height: 300px;
  margin-top: -25px;
}

.shop-distribute-container >>> .el-tabs__header {
  margin-bottom: 10px;
}

.shop-tab-header {
  padding: 10px 0;
  border-bottom: 1px solid #e4e7ed;
  margin-bottom: 10px;
}

.shop-tab-content {
  max-height: 300px;
  overflow-y: auto;
}

.shop-item {
  padding: 10px 0;
  border-bottom: 1px solid #ebeef5;
}

.shop-item:last-child {
  border-bottom: none;
}

.shop-name {
  font-size: 14px;
  color: #303133;
}

.selected-count {
  margin-right: 20px;
  color: #606266;
  font-size: 14px;
}

.price-range-separator {
  margin: 0 6px;
  color: #909399;
}
</style>
